// extracted by mini-css-extract-plugin
export var currencyInput = "_ou-1";
export var currencySymbol = "_ou-0";